/**
 * Shared test fixtures for the Edit User page, shaped like what
 * Management::UserDetail actually sends.
 *
 * A plain module rather than an export from one of the test files: importing a test
 * file into another makes its suite run twice.
 */

export const OPTIONS = {
  jobRoles: [
    { label: 'Fleet Manager', value: 'fleet_manager' },
    { label: 'Technician', value: 'technician' },
  ],
  countries: [
    { label: 'United States', value: 'US' },
    { label: 'Canada', value: 'CA' },
    { label: 'Puerto Rico', value: 'PR' },
  ],
  states: {
    // Puerto Rico genuinely has no subdivisions in GeoHashes.
    US: [{ label: 'Alabama', value: 'AL' }, { label: 'Texas', value: 'TX' }],
    CA: [{ label: 'Ontario', value: 'ON' }],
    PR: [],
  },
  phoneCountryCodes: [{ label: '+1', value: 1 }, { label: '+52', value: 52 }],
};

export const userFixture = (overrides = {}) => ({
  id: 7,
  fullName: 'Abe Martinez',
  firstName: 'Abe',
  lastName: 'Martinez',
  username: 'm.abe',
  jobRole: '',
  dmsId: '98761234',
  email: 'martinez@email.com',
  mobile: '(350) 579-3153',
  mobileCountryCode: 1,
  phone: '',
  // Null rather than a code: most rows have no number to attach one to, and
  // Management::UserDetail sends the column as it stands.
  phoneCountryCode: null,
  fax: '',
  faxCountryCode: null,
  address1: '',
  address2: '',
  countryCode: 'US',
  state: 'TX',
  city: 'Dallas',
  postalCode: '75001',
  accounts: ['Account Name A'],
  permissions: ['Fleet Administrator'],
  permissionAssignments: [
    { account: 'Account Name A', permission: 'Fleet Administrator' },
  ],
  lastLoginAt: '03/08/2025 05:22 PM MST',
  options: OPTIONS,
  ...overrides,
});

export default userFixture;
